import ApiService from "@/common/api.service";
import {LogoutService} from "@/common/api.service";
import JwtService from "@/common/jwt.service";

import {
    LOGIN,
    MICROSOFTLOGIN,
    MICROSOFTCALLBACK,
    LOGOUT,
    CHECK_AUTH,
    CHECK_TOKEN,
    UPDATE_PASSWORD,
    FORGOT_PASSWORD
} from "./actions.type";
import { SET_AUTH,PURGE_AUTH, SET_TOKEN_VALID ,SET_AUTH_ERROR } from "./mutations.type";

const state = {
    autherrors: [],
    tokenValid: false,
    user: null,
    userTokenData: null,
    isAuthenticated: !!JwtService.getToken()
  };

  const getters = {
    currentUser(state) {
      return state.user;
    },
    isAuthenticated(state) {
      return state.isAuthenticated;
    },
    tokenValid(state) {
      return state.tokenValid;
    },
    userTokenData(state) {
      return state.userTokenData;
    },       
  };

  const actions = {
    async [LOGIN](context, credentials) {
      return new Promise(resolve => {
        ApiService.post("login", credentials)
          .then(({ data }) => {
            context.commit(SET_AUTH, data.data);
            resolve(data);
          })
          .catch(({ response }) => {
            context.commit(SET_AUTH_ERROR, (response.data.hasOwnProperty('errors') ? response.data.errors : response.data.message));
          });
      });
    },
    [MICROSOFTLOGIN](context) {
      return new Promise(resolve => {
        ApiService.get("microsoft-auth/redirect")
          .then(({ data }) => {
            window.location.href=data.data;
            resolve(data);
          })
          .catch(({ response }) => {
            context.commit(SET_AUTH_ERROR, (response.data.hasOwnProperty('errors') ? response.data.errors : response.data.message));
          });
      });
    },
    async [MICROSOFTCALLBACK](context, param) {
      return new Promise(resolve => {
        ApiService.get("microsoft-auth/callback"+param)
          .then(({ data }) => {
            context.commit(SET_AUTH, data.data);
            resolve(data);
          })
          .catch(({ response }) => {
            context.commit(SET_AUTH_ERROR, (response.data.hasOwnProperty('errors') ? response.data.errors : response.data.message));
            resolve(response);
          });
      });
    },

    [FORGOT_PASSWORD](context,credentials){
      return ApiService.post("password/email", credentials)
      .then(({ data }) => {
        context.commit(SET_AUTH_ERROR, []);
        return data
      })
      .catch(({ response })  => {
        context.commit(SET_AUTH_ERROR, (response.data.hasOwnProperty('errors') ? response.data.errors : response.data.message));
      });
    },
    [UPDATE_PASSWORD](context, credentials) {
      return new Promise(resolve => {
        ApiService.post("password/reset", credentials)
          .then(({ data }) => {
            context.commit(SET_AUTH, data.data);
            resolve(data);
          })
          .catch(({ response }) => {
            context.commit(SET_AUTH_ERROR, (response.data.hasOwnProperty('errors') ? response.data.errors : response.data.message));
          });
      });
    },    
    async [CHECK_TOKEN](context, payload) {
       return await ApiService.get("password/reset/"+payload)
          .then(({ data }) => {
            context.commit(SET_TOKEN_VALID, data);
            return data
          })
          .catch(({ response }) => {
            context.commit(SET_AUTH_ERROR, (response.data.hasOwnProperty('errors') ? response.data.errors : response.data.message));
            return response
          });

    },     
    async [LOGOUT](context) {
      if(JwtService.getToken()){
        await LogoutService.get().then(resp =>{
          if(resp.status == 200)
            context.commit(PURGE_AUTH);
        })
      }
      else{
        await context.commit(PURGE_AUTH);
      }
    },
    async [CHECK_AUTH](context) {
      if (JwtService.getToken()) {
        ApiService.setHeader();
       return await ApiService.get("user")
          .then(({ data }) => {
            context.commit(SET_AUTH, data.data);
            return data
          })
          .catch(({ response }) => {
            if(response !=undefined)
            context.commit(SET_AUTH_ERROR, (response.data.hasOwnProperty('errors') ? response.data.errors : response.data.message));
          });
      } else {
        context.commit(PURGE_AUTH);
      }
    },
  };

  const mutations = {
    [SET_AUTH_ERROR](state, error) {
      state.autherrors = error;
    },
    [SET_TOKEN_VALID](state, data) {
      state.tokenValid = data.success
      state.userTokenData = data.data
    },    
    [SET_AUTH](state, data) {
      JwtService.saveToken(data.token);
      if (JwtService.getToken()) {
        ApiService.setHeader();
      }
      state.isAuthenticated = true
      state.user = data.user
      state.autherrors = {}
    },
    [PURGE_AUTH](state) {
      state.isAuthenticated = false;
      state.tokenValid = false;
      state.user = {};
      state.userTokenData = null;
      state.autherrors = {};
      JwtService.destroyToken();
    }
  };

  export default {
    state,
    actions,
    mutations,
    getters
  };
  